import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../context/AuthContext';

const T = {
  ko: { home: 'About', blog: '블로그' },
  en: { home: 'About', blog: 'Blog' },
};

export default function Nav({ lang, setLang }) {
  const [aboutOpen, setAboutOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const t = T[lang];

  useEffect(() => { setAboutOpen(false); }, [location]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <>
      <header style={styles.header}>
        <Link to="/" style={styles.title}>
          <span>너풀너풀</span> <em>studio</em>
        </Link>
        <div style={styles.navWrap}>
          <nav style={styles.nav}>
            <button
              style={{ ...styles.navLink, ...(aboutOpen ? styles.navLinkActive : {}) }}
              onClick={() => setAboutOpen(o => !o)}
            >
              {t.home}
            </button>

            <div style={styles.navRight}>
              {user && (
                <button style={styles.adminBtn} onClick={handleLogout}>
                  로그아웃
                </button>
              )}
              <button
                style={styles.langBtn}
                onClick={() => setLang(l => l === 'ko' ? 'en' : 'ko')}
              >
                {lang === 'ko' ? 'EN' : '한'}
              </button>
            </div>

            <Link
              to="/blog"
              style={{ ...styles.navLink, ...(location.pathname.startsWith('/blog') ? styles.navLinkActive : {}) }}
            >
              {t.blog}
            </Link>
          </nav>
        </div>
      </header>

      {/* About 드롭다운 */}
      <div style={{
        overflow: 'hidden',
        maxHeight: aboutOpen ? '340px' : '0',
        transition: 'max-height .5s cubic-bezier(.4,0,.2,1)',
        borderBottom: aboutOpen ? '1px solid var(--ink-pale)' : '1px solid transparent',
        backgroundColor: 'var(--paper)',
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0',
          opacity: aboutOpen ? 1 : 0,
          transition: 'opacity .3s ease .1s',
        }}>
          <img
            src="/nuhpul_about.png"
            alt="너풀너풀"
            style={{
              width: '100%',
              maxWidth: '960px',
              height: '300px',
              objectFit: 'cover',
              objectPosition: 'center 30%',
              display: 'block',
            }}
          />
        </div>
      </div>
    </>
  );
}

const styles = {
  header: { padding: '3rem 3rem 0', textAlign: 'center' },
  title: {
    fontFamily: 'var(--serif)',
    fontSize: 'clamp(2.4rem, 5vw, 3.6rem)',
    fontWeight: 300, letterSpacing: '-.02em',
    color: 'var(--ink)', lineHeight: 1, display: 'inline-block',
  },
  navWrap: {
    maxWidth: '960px',
    margin: '0 auto',
  },
  nav: {
    marginTop: '1.2rem', display: 'flex',
    justifyContent: 'space-between', alignItems: 'center',
    borderTop: '1.5px solid var(--ink)',
    borderBottom: '1px solid var(--ink)',
    padding: '.55rem 0',
  },
  navRight: { display: 'flex', alignItems: 'center', gap: '1rem' },
  navLink: {
    fontFamily: 'var(--mono)', fontSize: '.68rem',
    letterSpacing: '.14em', textTransform: 'uppercase',
    color: 'var(--ink-mid)', background: 'none',
    border: 'none', padding: 0, cursor: 'pointer',
  },
  navLinkActive: { color: 'var(--ink)' },
  langBtn: {
    fontFamily: 'var(--mono)', fontSize: '.62rem', letterSpacing: '.1em',
    background: 'none', border: 'none', color: 'var(--ink-soft)', cursor: 'pointer', padding: 0,
  },
  adminBtn: {
    fontFamily: 'var(--mono)', fontSize: '.55rem', letterSpacing: '.12em',
    textTransform: 'uppercase', color: 'var(--ink-soft)',
    background: 'none', border: '1px solid var(--ink-pale)',
    padding: '.2rem .6rem', borderRadius: '20px', cursor: 'pointer',
  },
};
